import {useRealtimeChannel, useRealtimePublisher} from "@/api/realtime/RealtimeChannelHooks.ts";
import {ViewPort} from "@/encounter/model/ViewPort.ts";

export function useViewPortRealtime(encounterId: string) {
    const {subscribe} = useRealtimeChannel<ViewPort>(`/encounters/${encounterId}/viewPort`);
    const publishLive = useRealtimePublisher<ViewPort>(`/encounters/${encounterId}/viewPort/live`);
    return {subscribeToUpdates: subscribe, publishLive};
}
